import { render } from "./BarLoader.vue?vue&type=template&id=37018996"
const script = {}

import "./BarLoader.vue?vue&type=style&index=0&id=37018996&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/sd-app-pipe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__